import React from 'react';

import { languageManager } from '../utils/languageManager'

import FwTutorialComponent from './FwTutorialComponent'

export class FwTutorialClass {

  constructor() {
    this.showTutorial = false;
    this.state = {
      currentTutorialStep: 0,
      showTutorial: false,
    };
  }

  setShowTutorial = (val) => {
    console.log('Pone a que muestre el tutorial',val);
    this.showTutorial = val;
  }

  getShowTutorial = () => {
    return this.showTutorial;
  }

  setSteps = (newSteps) => {
    if(newSteps!==this.steps) {
      this.steps = newSteps;
      this.state.currentTutorialStep = 0;
      this.refreshComponentState();
    }
  }

  getComponent = () => {

    console.log('Pasa a retornar con',this.showTutorial);
    if(!this.showTutorial || this.steps === undefined || this.steps.length == 0) return null;

    const steps = this.steps;/*[
        {
          element: '#itemNoSlides',
          intro: languageManager.getLangWord('PC_TUTORIAL_STEP0'),
        },
        {
          element: '#item0',
          intro: languageManager.getLangWord('PC_TUTORIAL_STEP1'),
        },
        {
          element: '#column_edition',
          intro: languageManager.getLangWord('PC_TUTORIAL_STEP2'),
        },
        {
          element: '#savePart',
      intro: languageManager.getLangWord('PC_TUTORIAL_STEP3'),
        },
        {
          element: '#uploadPart',
      intro: languageManager.getLangWord('PC_TUTORIAL_STEP4'),
        },
    ];*/

    return (<FwTutorialComponent steps={steps} regStepsParent={this.regStepsParent} regStepsState={this.regStepsState}/>)
  }

  colocarEstadoTutorial = (step,delay=0) => {
    
    if(delay>0) {
      setTimeout(() => {this.colocarEstadoTutorial(step)},delay);
      return;
    }

    console.log('Quiere poner el TUTO ',step," y tiene",this.state.currentTutorialStep,"show",this.state.showTutorial);

    //Si ya esta en el estado al que va entonces no hace nada, a no ser de que aun no se
    //este mostrando el tutorial
    if(step===this.state.currentTutorialStep && this.state.showTutorial) {
      return false;
    } 

    if(step>=0) {
      if(this.introJsStepObj) {
        this.introJsStepObj.updateStepElement(step);
        this.introJsStepObj.manualGoto(step+1);
      }
      
      console.log('Lo pone en true aca con ',this.setState);
      this.state.showTutorial = true;
      this.state.currentTutorialStep = step;

      this.refreshComponentState();      
    }
    else {
      this.state.showTutorial = false;
      this.state.currentTutorialStep = 0;

      this.refreshComponentState();            
    }
    
    return true;
  }

  refreshComponentState = () => {
    if(this.setState) this.setState({showTutorial: this.state.showTutorial,currentTutorialStep:this.state.currentTutorialStep});      
  }

  regStepsParent = (introJsStepObj) => {
    console.log('Guarda la referencia',introJsStepObj,"en",this);
    this.introJsStepObj = introJsStepObj;
  }

  regStepsState = (stateFunction) => {      
    console.log('Guarda la funcion de setState');
    this.setState = stateFunction;
    this.refreshComponentState();
  }      
}  


// WEBPACK FOOTER //
// ./src/containers/components/FwTutorialClass.js